import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import HybridFlooring from "@/pages/HybridFlooring";
import Accessories from "@/pages/Accessories";
import Services from "@/pages/Services";
import Colours from "@/pages/Colours";
import Projects from "@/pages/Projects";
import About from "@/pages/About";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/hybrid-flooring" element={<HybridFlooring />} />
            <Route path="/accessories" element={<Accessories />} />
            <Route path="/services" element={<Services />} />
            <Route path="/colours" element={<Colours />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/get-a-free-quote" element={<Quote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
